export const DATE_BUBBLE_HEIGHT = 22;
